<template>
  <div class="detail-pages display-grid gap-10 tw-mb-15 tw-px-5 lg:tw-px-0">
    <div class="detail-pages-title px-20 px-lg-0 display-none display-lg-block">
      <h1 class="typo-h1 mb-0">
        {{ $t('help.contact.page-title') }}
      </h1>
    </div>
    <div class="content-wrapper tw-mb-7">
      <p class="tw-whitespace-pre-wrap">{{ $t('help.contact.page-content') }}</p>

      <nuxt-img src="/assets/images/contact-support-illustration.png" alt="Contact Us" loading="lazy" />
    </div>

    <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-8">
      <div
        @click="openLiveChat"
        data-testid="open-live-chat-option"
        class="tw-rounded tw-py-[15px] tw-px-5 tw-bg-white tw-shadow tw-relative tw-flex tw-gap-4 tw-items-center tw-cursor-pointer"
      >
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 14C0 6.26802 6.26801 0 14 0H24.7333C26.5375 0 28 1.46254 28 3.26667V14C28 21.732 21.732 28 14 28C6.26802 28 0 21.732 0 14Z"
            fill="#F46863"
          />
          <path
            d="M8.55566 13.3775C8.55566 11.4875 10.0878 9.95532 11.9779 9.95532H16.0223C17.9124 9.95532 19.4446 11.4875 19.4446 13.3775V14.622C19.4446 16.512 17.9124 18.0442 16.0223 18.0442H9.489C8.97353 18.0442 8.55566 17.6263 8.55566 17.1109V13.3775Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.2671 12.8334C10.2671 12.5756 10.476 12.3667 10.7338 12.3667H17.1115C17.3693 12.3667 17.5782 12.5756 17.5782 12.8334C17.5782 13.0911 17.3693 13.3 17.1115 13.3H10.7338C10.476 13.3 10.2671 13.0911 10.2671 12.8334Z"
            fill="#F46863"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.2671 15.2445C10.2671 14.9868 10.476 14.7778 10.7338 14.7778H14.6226C14.8804 14.7778 15.0893 14.9868 15.0893 15.2445C15.0893 15.5022 14.8804 15.7112 14.6226 15.7112H10.7338C10.476 15.7112 10.2671 15.5022 10.2671 15.2445Z"
            fill="#F46863"
          />
        </svg>

        <div class="tw-w-full tw-flex tw-justify-between tw-items-center tw-gap-1">
          <div class="tw-text-primary tw-text-15 tw-font-medium">
            {{ $t('help.contact.chat-button') }}
          </div>

          <i class="rtl:tw-hidden airalo-icon-arrow-right tw-text-3" />
          <i class="ltr:tw-hidden airalo-icon-arrow-left tw-text-3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Contact',
    head() {
      return {
        title: this.$t('seo.contact.title'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('seo.contact.description'),
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.$t('seo.contact.keywords'),
          },
          {
            property: 'og:title',
            content: this.$t('seo.contact.title'),
          },
          {
            property: 'og:description',
            content: this.$t('seo.contact.description'),
          },
        ],
      }
    },

    methods: {
      openLiveChat() {
        if (window.zE) {
          zE('messenger', 'open')
        }
      },
    },

    scrollToTop: true,
  }
</script>
